module.exports = __webpack_public_path__ + "img/T5-D-xh_7.cc570261.png";